module.exports = __webpack_public_path__ + "img/case-ct_compactvanguards_full.3291971.png";